import { Text } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";
import RowStats, { type Stat } from "../RowStats";
import { FlatCard } from "./FlatCard";

type Props = {
	title: string;
	tooltip?: string;
	subtitle: string;
	stats: Stat[];
	insights: string;
};
const StrenghtsAndWeaknessCard = ({ title, subtitle, stats }: Props) => {
	const theme = useAppTheme();
	return (
		<FlatCard>
			<Box padding={16} gap={16}>
				<Box gap={4}>
					<Text variant="titleMedium">{title}</Text>
					{subtitle ? (
						<Text
							variant="bodySmall"
							style={{ color: theme.colors.onSurfaceVariant }}
						>
							{subtitle}
						</Text>
					) : null}
				</Box>
				<RowStats stats={stats} style={{ margin: "auto", width: "100%" }} />
			</Box>
		</FlatCard>
	);
};

export default StrenghtsAndWeaknessCard;
